export const authConfig = {
  clientId: window.env.REACT_APP_CLIENT_ID,
  issuer: window.env.REACT_APP_ISSUER,
  redirectUri: `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  disableHttpsCheck: window.env.REACT_APP_LOGIN_HTTPS_CHECK,
};
